import React from 'react';
import './DeleteData.scss';
import DeleteFile1 from '../../assets/DeleteFile1.png';
import DeleteFile2 from '../../assets/DeleteFile2.png';
import DeleteFile3 from '../../assets/DeleteFile3.png';
import DeleteFile4 from '../../assets/DeleteFile4.png';

import DeleteFolder1 from '../../assets/DeleteFolder1.png';
import DeleteFolder2 from '../../assets/DeleteFolder2.png';
import DeleteFolder3 from '../../assets/DeleteFolder3.png';
import DeleteFolder4 from '../../assets/DeleteFolder4.png';

export default function DeleteData() {

  const data = [
    {
      title: 'How to delete files in MyPDF app?',
      details: [
        {
          heading: 'Step 1: Go to Documents and Select Files',
          point:
            'Open the MyPDF app and tap on the Documents tab in the bottom navigation bar. At the top of the screen, use the toggle switch to select Files, which displays all your saved Files.',
          icon: DeleteFile1
        },
        {
          heading: 'Step 2: Tap the Options Menu for the File',
          point:
            'Scroll through the list of files and locate the one you want to delete. Tap on the three-dot menu icon (⋮) next to the file to open additional actions.',
          icon: DeleteFile2
        },
        {
          heading: 'Step 3: Select Delete from the Menu',
          point:
            'From the options shown, tap on Delete to begin the file removal process.',
          icon: DeleteFile3
        },
        {
          heading: 'Step 4: Confirm the Deletion',
          point:
            'A confirmation dialog box will appear asking if you’re sure you want to delete the file. Tap Delete once again to permanently remove it from your storage.',
          icon: DeleteFile4
        },
      ]
    },

    {
      title: 'How to delete folders in MyPDF app?',
      details: [
        {
          heading: 'Step 1: Navigate to Documents and Switch to Folders',
          point:
            'Launch the MyPDF app and open the Documents section from the bottom navigation bar. At the top of the screen, set the toggle to Folders to view all your stored folders',
          icon: DeleteFolder1
        },
        {
          heading: 'Step 2: Tap the Options Menu for the Folder',
          point:
            'Find the folder you want to delete, then tap the three-dot menu icon (⋮) beside it to open the available options',
          icon: DeleteFolder2
        },
        {
          heading: 'Step 3: Select Delete from the Menu',
          point:
            'From the list of actions, choose Delete to initiate the folder removal.',
          icon: DeleteFolder3
        },
        {
          heading: 'Step 4: Confirm the Deletion',
          point:
            'A confirmation dialog box will appear asking if you’re sure you want to delete the folder. Tap Delete once again to permanently remove it from your storage.',
          icon: DeleteFolder4
        },
      ]
    },
  ];

  return (
    <section className='delete-data-container'>
      <section className='heading-container'>
        <h1>Manage and Delete Your Data in MyPDF.club</h1>
        <h2>
          Follow the guide below to securely delete your files or folders from MyPDF app.
        </h2>
        <p> Published on April 12, 2025</p>
      </section>

      
        {data.map((item, index) =>
          <>
            <h2>{index+1}. {item.title}</h2>

            {item.details.map((element, index) => 
              <section
                className={`delete-details-container ${(index > 0 && (index % 2 !== 0)) ? 'active' : ''}`}
              >
                <div className='left-details'>
                  <h3>{element.heading}</h3>
                    <p>{element.point}</p>
                </div>
                <div className='image-container'>
                  <img src={element.icon} alt={element.icon} />
                </div>
              </section>
            )}
          </>
        )}
      
    </section>
  )
}
